export default "__VITE_ASSET__17b32422__"